import {
  PropertyTranslator,
  IRelatedEntityLabels,
  INamedEntityParametersTranslator,
  INamedEntityLabels,
  IPermissionedEntityLabels,
  IGenericRequestParametersTranslator,
  IPaginationParametersTranslator,
} from "../GenericTranslator";
import {
  GenericEntityOrderBy,
  EntityConstants,
  IEntityMinimalModel,
  IGenericRequestParameters,
  IModelWithIntId,
  INamedEntity,
  INamedEntityParameters,
  IPaginationParameters,
  IPermissionedEntity,
  IRelatedEntity,
  IRelationModel,
  NamedEntityOrderBy,
} from "../GenericTypes";

export const customTypeTemplatePackageConstants: EntityConstants<
  CustomTypeTemplatePackage,
  CustomTypeTemplatePackageFilters
> = {
  resource: "custom_type_template_packages",
  frontendIndexRoute: "custom_type_template_packages",
  entitySingular: "template package",
  entityPlural: "template packages",
  icon: "package",
};

export interface CustomTypeTemplatePackage
  extends IModelWithIntId,
    INamedEntity,
    IPermissionedEntity,
    IRelatedEntity<CustomTypeTemplatePackageRelations> {
  description?: string;
}

export const CustomTypeTemplatePackageFieldLabels: PropertyTranslator<CustomTypeTemplatePackage> = {
  id: "Custom type template package ID",
  ...INamedEntityLabels,
  ...IPermissionedEntityLabels,
  ...IRelatedEntityLabels,
  description: "Description",
} as const;

export interface CustomTypeTemplatePackageRelations extends IRelationModel {}

export interface CustomTypeTemplatePackageSuggestions extends IEntityMinimalModel<CustomTypeTemplatePackage["id"]> {
  description?: string;
}

export interface CustomTypeTemplatePackageFilters
  extends IPaginationParameters,
    IGenericRequestParameters<CustomTypeTemplatePackage, CustomTypeTemplatePackageSortingOptions>,
    INamedEntityParameters {
  customFieldTemplateIds?: number[] | null;
}

export const CustomTypeTemplatePackageSortingOptionsConsts = [...GenericEntityOrderBy, ...NamedEntityOrderBy] as const;
export type CustomTypeTemplatePackageSortingOptions = (typeof CustomTypeTemplatePackageSortingOptionsConsts)[number];

export const CustomTypeTemplatePackageFiltersTranslator: PropertyTranslator<CustomTypeTemplatePackageFilters> = {
  ...IGenericRequestParametersTranslator,
  ...IPaginationParametersTranslator,
  ...INamedEntityParametersTranslator,
  customFieldTemplateIds: "Custom field template ID(s)",
} as const;
